import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

import ModalFrame from '../../common/_ModalFrame.jsx';
import HelpCenterHeader from '../support/_HelpCenterHeader.jsx';
import CrowdNavigation from '../common/_CrowdNavigation.jsx';

export default class CrowdPastLanding extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
		};
	}

	componentDidMount() {
	}

	render() {
		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={5}/> : null}
				<HelpCenterHeader title="Past Programs"/>
				<div className="main">
					<div className="main__content">
						{this.renderPrograms()}
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderPrograms() {
		return (
			<div className="card-container past-program-card__container">
				<article className="past-program-card">
					<a href={blapp.url2.getCrowdProjectPastMPSUrl()} className="past-program-card__internal">
						<div className="past-program-card__image past-program-card__image--mps">
							<div className="past-program-card__image-internal">
								<img src={`//${blapp.config.getHost( "static2" )}/img/mocpopup/logo.png`} className="past-program-card__image-item past-program-card__image-item--mps"/>
							</div>
						</div>
						<div className="past-program-card__main">
							<h2 className="past-program-card__title">MOC Pop-Up Store</h2>
							<div className="past-program-card__meta-item past-program-card__meta-item--date"><i className="far fa-fw fa-calendar l-margin-right"/>2023</div>
							<div className="past-program-card__meta-item past-program-card__meta-item--designs"><i className="far fa-fw fa-lightbulb-on l-margin-right"/>50 designs</div>
						</div>
					</a>
				</article>
				<article className="past-program-card">
					<a href={blapp.url2.getCrowdProjectPastBDPUrl()} className="past-program-card__internal">
						<div className="past-program-card__image past-program-card__image--bdp">
							<div className="past-program-card__image-internal">
								<img src={`//${blapp.config.getHost( "static2" )}/img/bdp/bdp-logo.svg`} className="past-program-card__image-item"/>
							</div>
						</div>
						<div className="past-program-card__main">
							<h2 className="past-program-card__title">BrickLink Designer Program</h2>
							<div className="past-program-card__meta-item past-program-card__meta-item--date"><i className="far fa-fw fa-calendar l-margin-right"/>2021-2022</div>
							<div className="past-program-card__meta-item past-program-card__meta-item--designs"><i className="far fa-fw fa-lightbulb-on l-margin-right"/>15 designs</div>
						</div>
					</a>
				</article>
				<article className="past-program-card">
					<a href={blapp.url2.getCrowdProjectPastADPUrl()} className="past-program-card__internal">
						<div className="past-program-card__image past-program-card__image--adp">
							<div className="past-program-card__image-internal">
								<img src={`//${blapp.config.getHost( "static2" )}/img/adp/60years.png`} className="past-program-card__image-item"/>
							</div>
						</div>
						<div className="past-program-card__main">
							<h2 className="past-program-card__title">AFOL Designer Program</h2>
							<div className="past-program-card__meta-item past-program-card__meta-item--date"><i className="far fa-fw fa-calendar l-margin-right"/>2018-2019</div>
							<div className="past-program-card__meta-item past-program-card__meta-item--designs"><i className="far fa-fw fa-lightbulb-on l-margin-right"/>13 designs</div>
						</div>
					</a>
				</article>
			</div>
		);
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<CrowdPastLanding blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-crowd' )
						);
		blapp.refs.register( "main", elem );
	}
);
